// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdNotifications } from 'react-icons/lib/md';

import Popup from '../../Popup';
import * as closeableActions from '../../../actions/closeable';
import * as changeStopRequestActions from '../../../actions/changeStopRequests';
import ChangeStopPopover from '../ChangeStopPopover';
import Button from '../../Button';
import { ReduxClickPopover } from '../../Closeable';

type ChangeStopActionButtonTypes = {
  onClick: Function,
  title: string,
  onOpen: Function,
  id: string,
  state: string,
  instance_type: string,
  requireConfirmation: boolean,
  updateStateChangeStopRequestStarted: Function,
}

const CHANGE_STOP_DETAIL_POPOVER = 'CHANGE_STOP_DETAIL_POPOVER';


const ChangeStopActionButton = ({
  onClick,
  title,
  onOpen,
  id,
  state,
  instance_type,
  requireConfirmation = true,
  updateStateChangeStopRequestStarted,
  ...props
}: ChangeStopActionButtonTypes) => (
  <Fragment>
    <Popup
      id={`${CHANGE_STOP_DETAIL_POPOVER}_${title}_${id}`}
      theme="main"
      transitionMs={600}
    >
      <ChangeStopPopover
        onUpdate={updateStateChangeStopRequestStarted}
      />
    </Popup>
    <Button
      {...props}
      title={title}
      onClick={requireConfirmation ? onOpen : () => updateStateChangeStopRequestStarted('')}
    />
  </Fragment>
  /* <ReduxClickPopover
      isInline
      id={`${CHANGE_STOP_DETAIL_POPOVER}_${title}_${id}`}
      Content={ChangeStopPopover}
      vertical="above"
      horizontal="middle"
      tipPosition="middle"
      isRound="true"
      onUpdate={updateStateChangeStopRequestStarted}
      isPopover
    >

    </ReduxClickPopover> */
);

export default connect(
  undefined,
  (dispatch, {
    title, id, state, instance_type,
  }) => ({
    onOpen() {
      dispatch(closeableActions.open(`${CHANGE_STOP_DETAIL_POPOVER}_${title}_${id}`));
    },
    updateStateChangeStopRequestStarted(description: string) {
      dispatch(
        changeStopRequestActions.updateStateChangeStopRequestStarted(id, instance_type, state, description),
      );
    },
  }),
)(ChangeStopActionButton);



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/ChangeStopActionButton/index.jsx